// From https://github.com/w3c/aria-practices/blob/master/examples/js/utils.js
export const isFocusable = (element, allowHeaders = false) => {
  if (
    element.tabIndex > 0 ||
    (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null)
  ) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  if (
    allowHeaders &&
    element.nodeType === Node.ELEMENT_NODE &&
    (element.getAttribute('role') === 'title' ||
      element.getAttribute('role') === 'heading' ||
      element.getAttribute('aria-role') === 'heading' ||
      ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(element.tagName))
  ) {
    return true;
  }

  switch (element.nodeName) {
  case 'A':
    return !!element.href && element.rel !== 'ignore';
  case 'INPUT':
    return element.type !== 'hidden' && element.type !== 'file';
  case 'BUTTON':
  case 'SELECT':
  case 'TEXTAREA':
    return true;
  default:
    return false;
  }
};

/**
 * Find and returns all children of an element that can receive focus e.g. inputs, buttons, links, etc.
 * @param {HTMLElement} element Root element to start recursively searching from
 * @param {bool} allowHeaders boolean if true allows headers or elements with a role of header / title to be focusable
 * @returns {[HTMLElement]} Flattened array of children of element that can receive focus; ordered as in dom focus order
 */
export const getFocusableChildren = (element, allowHeaders = false) => {
  let checkChild = (output, toProcess) => {
    if (!toProcess.length) {
      return output;
    }

    let node = toProcess.shift();

    if (isFocusable(node, allowHeaders)) {
      output.push(node);
    } else if (node.hasChildNodes()) {
      toProcess = [...node.childNodes].concat(toProcess);
    }

    return checkChild(output, toProcess);
  };

  return checkChild([], [element]);
};

/**
 * Check if element has any focusable children
 * @param {HTMLElement}     element     Root element to check if any children are focusable from
 * @returns {boolean}                   Return true iff any children of element are focusable
 */
export const anyFocusableChildren = (element) => {
  let checkChild = (toProcess) => {
    if (!toProcess.length) {
      return false;
    }

    let node = toProcess.shift();

    if (isFocusable(node)) {
      return true;
    }

    if (node.hasChildNodes()) {
      toProcess = [...node.childNodes].concat(toProcess);
    }

    return checkChild(toProcess);
  };

  return checkChild([element]);
};
